// Moving between tabs, and jumping to a job from anywhere.
import { baseQuote, isDone } from '@shared/index';
import { store, ui } from './store';
import { render } from './render';
import { $ } from './ui';

export type Tab = 'overview' | 'jobs' | 'calendar' | 'todo' | 'admin';

export function currentTab(): Tab {
  const t = ({ '#jobs': 'jobs', '#calendar': 'calendar', '#todo': 'todo', '#admin': 'admin' } as Record<string, Tab>)[location.hash] || 'overview';
  return t === 'admin' && store.profile?.role !== 'admin' ? 'overview' : t;
}

export function showTab() {
  const t = currentTab();
  (['overview', 'jobs', 'calendar', 'todo', 'admin'] as Tab[]).forEach((v) => { $('view-' + v).hidden = t !== v; });
  document.querySelectorAll<HTMLAnchorElement>('.tabs a').forEach((a) => a.dataset.tab === t ? a.setAttribute('aria-current', 'page') : a.removeAttribute('aria-current'));
}

/** Filter the Jobs tab to one PM ("" = all) and redraw. */
export function setPm(pm: string) {
  ui.pm = pm;
  render();
}

/** Open a job (or the job a stage belongs to) in the Jobs tab, expanded. */
export function openJob(quote: string) {
  const stg = store.stages.find((x) => x.id === quote);
  if (stg) { ui.open.add(quote); quote = stg.parent_quote; }
  const j = store.jobs.find((x) => x.quote === quote);
  if (!j) return;
  ui.view = isDone(j) ? 'done' : 'active';
  ui.filter = '';
  ui.q = quote;
  ($('q') as HTMLInputElement).value = quote;
  ui.open.add(quote);
  ui.open.add(baseQuote(quote));
  setPm(j.pm);
  location.hash = '#jobs';
}
